import type { Variant } from '@storefront/lib-global/codegen/types';
import { StockStatus } from '@storefront/lib-global/codegen/types';

export const isEveryVariantInStock = (variants: Variant[]): boolean =>
  variants.every((variant) => variant.stock.status === StockStatus.INSTOCK);
